import React, { useState } from "react";
import ColorPicker from "../../ColorPicker";

const ThemeTab = ({ updateChatTabData,chatTabData }) => {
    const [activeThemeType, setActiveThemeType] = useState(chatTabData.theme_type);
    const [accentColor, setAccentColor] = useState(chatTabData.accent_color);

    // Handle Theme Type input change
    const handleActiveThemeTypeChange = (event) => {
        setActiveThemeType(event.target.value);
        updateChatTabData("theme_type", event.target.value);
    };

    // Handlers Accent Color Change
    const handleAccentColorChange = (color) => {
        setAccentColor(color.hex);
        updateChatTabData("accent_color", color.hex);
    };

    return (
        <div className="side-baar-inner-setting">
            <>
            <span>Theme</span>
            <div className="card h-100 position-tabe">
                <div className="label-box-flex labelfour_box">
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-1" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-1"}/>
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="200" height="100" viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="100%" height="100%" fill="white" rx="10" />
                                    <rect x="10" y="20" rx="15" ry="15" width="100" height="30" fill="#e5e5ea" />
                                    <rect x="90" y="60" rx="15" ry="15" width="100" height="30" fill="#007aff" />
                                </svg>
                            </div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-2" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-2"}  />
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="240" height="160" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="100%" height="100%" rx="20" fill="white" stroke="black" stroke-width="1"/>
                                    <rect x="0" y="0" width="240" height="30" fill="#007aff" />
                                    <g>
                                        <rect x="15" y="50" width="120" height="30" rx="15" fill="#e5e5ea" />
                                    </g>
                                    <g>
                                        <rect x="105" y="95" width="120" height="30" rx="15" fill="#007aff" />
                                        <path d="M 105 110 L 95 106 L 105 100 Z" fill="#007aff" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-3" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-3"} />
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="240" height="160" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="100%" height="100%" rx="20" fill="#e6e6e6" stroke="black" stroke-width="1"/>
                                    <g>
                                        <rect x="15" y="40" width="120" height="30" rx="15" fill="#ffffff" />
                                        <path d="M 15 55 L 5 51 L 15 45 Z" fill="#ffffff" />
                                    </g>
                                    <g>
                                        <rect x="105" y="95" width="120" height="30" rx="15" fill="#007aff" />
                                        <path d="M 225 110 L 235 106 L 225 100 Z" fill="#007aff" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-4" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-4"} />
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="240" height="160" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="100%" height="100%" rx="20" fill="white" />
                                    <rect x="0" y="40" width="240" height="120" fill="#d5e9ff" />
                                    <g>
                                        <rect x="15" y="60" width="120" height="30" rx="15" fill="#ffffff" />
                                        <path d="M 15 75 L 5 71 L 15 65 Z" fill="#ffffff" />
                                    </g>
                                    <g>
                                        <rect x="105" y="105" width="120" height="30" rx="15" fill="#007aff" />
                                        <path d="M 225 120 L 235 116 L 225 110 Z" fill="#007aff" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-5" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-5"} />
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="240" height="160" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stop-color="#0f66e8" />
                                        <stop offset="100%" stop-color="#2196f3" />
                                        </linearGradient>
                                    </defs>
                                    <rect width="100%" height="100%" rx="20" fill="white" />
                                    <rect x="0" y="0" width="240" height="40" fill="url(#blueGradient)" />
                                    <rect x="0" y="40" width="240" height="120" fill="#d5e9ff" />
                                    <g>
                                        <rect x="15" y="60" width="120" height="30" rx="15" fill="#ffffff" />
                                        <path d="M 15 75 L 5 71 L 15 65 Z" fill="#ffffff" />
                                    </g>
                                    <g>
                                        <rect x="105" y="105" width="120" height="30" rx="15" fill="#007aff" />
                                        <path d="M 225 120 L 235 116 L 225 110 Z" fill="#007aff" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </label>
                    <label className="card-radio-btn">
                        <input type="radio" name="position_type" className="card-input-element d-none" value="theme-6" onChange={handleActiveThemeTypeChange} checked={activeThemeType === "theme-6"} />
                        <div className="card card-body">
                            <div className="content_head">
                                <svg width="240" height="160" viewBox="0 0 240 160" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="100%" height="100%" rx="20" fill="#0f0f0f" />
                                    <line x1="0" y1="40" x2="240" y2="40" stroke="#333" stroke-width="1" />
                                    <g>
                                        <rect x="15" y="60" width="120" height="30" rx="15" fill="#3a3a3c" />
                                        <path d="M 15 75 L 5 71 L 15 65 Z" fill="#3a3a3c" />
                                    </g>
                                    <g>
                                        <rect x="105" y="105" width="120" height="30" rx="15" fill="#007aff" />
                                        <path d="M 225 120 L 235 116 L 225 110 Z" fill="#007aff" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Font</span>
                    <em>Default</em>
                </div>
                <div className="box-header-row">
                    <span>Accent Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={accentColor} setColor={setAccentColor} onChangeComplete={handleAccentColorChange} />
                    </div>
                </div>
            </div>
            </>
        </div>
    );
};

export default ThemeTab;